module.exports = __webpack_public_path__ + "img/dink-kitchen-3.cb0f1769.jpeg";